import axios from "axios"
import Showdown from "showdown";


export default class TermsController {

    constructor(view) {
        this.view = view
        this.fetch()
    }

    fetch() {
        let url = "/assets/content/terms.md"
        axios.get(url).then((response) => {
            let data = response.data
            console.log(data)
            this.parse(data)
        })
    }

    parse(data) {
        
        let converter = new Showdown.Converter()
        let html = converter.makeHtml(data)
        console.log(html)
        this.view.terms = html
    }




}